// Install the reCAPTCHA-noise error suppressor FIRST — must run before
// React (and therefore react-error-overlay) registers its listeners so the
// benign "Invalid reCAPTCHA client id" errors emitted by Firebase's phone
// auth cleanup never trigger the dev-mode error overlay.
import "@/lib/recaptcha-noise-suppressor";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
